const initialState = {
  data: [],
  total: 1,
  params: {},
  allData: {},
  isps: [],
  users: {},
};

const reporte = (state = initialState, action) => {
  switch (action.type) {
    case 'GET_ALL_DATA_REPORT_ISP':
      return {...state, allData: action.data};
    case 'GET_DATA_REPORT_ISP':
      console.log('GET_DATA_REPORT_IS');
      return {...state, isps: action.data};
    case 'GET_ALL_DATA_REPORT_USERS':
      console.log('GET_ALL_DATA_REPORT_USERS');
      return {...state, users: action.data};
    case 'GET_ALL_DATA_REPORT_ISPW':
      return {
        ...state,
        allData: action.allData,
        data: action.data,
        total: action.totalPages,
        params: action.params,
      };
    case 'DELETE_INVOICE':
      return {...state};
    default:
      return {...state};
  }
};
export default reporte;
